import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
  InputAdornment,
  Checkbox,
  Collapse,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as ExpandRightAddCompetency } from "../../../../assets/icons/expandRightAddCompetency.svg";
import { ReactComponent as ExpandDownAddCompetency } from "../../../../assets/icons/expandDownAddCompetency.svg";
import { ReactComponent as CloseRed } from "../../../../assets/icons/closeRed.svg";
import emty from "../../../../assets/images/emty.png";
import Search from "@mui/icons-material/Search";
import * as Util from "../../../../services/global.service";
import ConfirmDialog from "../../../../components/ConfirmDialog";

const SimpleDialog = (props) => {
  let { close, open, itemsAdd, itemsCompetency, next } = props
  const { t } = useTranslation();
  const [search, setSearchValue] = React.useState("");
  const [item, setItem] = React.useState([]);
  const [MainItem, setMainItem] = React.useState([]);
  const [olditemsCompetency, setOlditemsCompetency] = React.useState([]);
  const [competencyMapping, setCompetencyMapping] = React.useState([]);
  const [listCompetency, setListCompetency] = React.useState([]);
  const [expandGroup, setExpandGroup] = React.useState([]);
  const [selectGroup, setSelectGroup] = React.useState([]);
  const [expand, setExpand] = React.useState([]);
  const [select, setSelect] = React.useState([]);
  const [isConfirmOpen, openConfirm] = React.useState(false);
  const handleConfirm = (val) => {
    openConfirm(val);
  };
  const handleConfirmDeleteList = () => {
    openConfirm(false)
    handleClose()
  };
  const handleClose = () => {
    close()
  };
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    let odata = []
    if (open && Util.formatData(olditemsCompetency, false) !== false && olditemsCompetency.length > 0) {
      for (let index = 0; index <= olditemsCompetency.length - 1; index++) {
        if (Util.formatData(olditemsCompetency[index]?.competencies, false) !== false && olditemsCompetency[index]?.competencies.length > 0) {
          for (let id = 0; id <= olditemsCompetency[index].competencies.length - 1; id++) {
            odata.push(olditemsCompetency[index].competencies[id]?.serial)
          }
        }
      }
    }
    setSelectGroup([])
    setSelect(odata)
  }, [open]);

  useEffect(() => {
    setCompetencyMapping(Util.formatData(itemsAdd?.competency_mapping, false) !== false ? itemsAdd?.competency_mapping : [])
    setListCompetency(Util.formatData(itemsAdd?.list_competency, false) !== false ? itemsAdd?.list_competency : [])
    setItem(Util.formatData(itemsAdd?.list_competency, false) !== false ? itemsAdd?.list_competency : [])
    setMainItem(Util.formatData(itemsAdd?.list_competency, false) !== false ? itemsAdd?.list_competency : [])
  }, [itemsAdd]);

  useEffect(() => {
    setOlditemsCompetency(itemsCompetency)
  }, [itemsCompetency]);

  useEffect(() => {
    let result = []
    let dataSerach = JSON.parse(JSON.stringify(MainItem))
    if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
      let resultData = dataSerach.filter(rs => {
        return Object.keys(rs).some(key => {
          if (key === 'name' || key === 'code') {
            return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
          }
          if (key === 'category_group' || key === 'competency_type') {
            return rs[key].name.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
          }
        });
      });
      result = resultData
    } else {
      result = dataSerach;
    }
    setItem(result)
  }, [search]);

  useEffect(() => {
    if (search !== "") {
      setSearchValue("")
    }
    if (selectGroup.length > 0) {
      let newData = []
      for (let index = 0; index <= competencyMapping.length - 1; index++) {
        if (Util.formatData(competencyMapping[index]?.competency_category_subgroup, false) !== false) {
          let filterData = competencyMapping[index]?.competency_category_subgroup.filter((rs) => {
            let filterSelectGroup = selectGroup.filter((dt) => dt === rs?.serial)
            if (filterSelectGroup.length > 0) {
              return true
            } else {
              return false
            }
          })
          if (filterData.length > 0) {
            for (let row = 0; row <= filterData.length - 1; row++) {
              if (Util.formatData(filterData[row]?.competencies, false) !== false && filterData[row]?.competencies.length > 0) {
                newData = [...newData, ...filterData[row].competencies]
              }
            }
          }
        } else if (Util.formatData(competencyMapping[index]?.competency_category_group, false) !== false) {
          let filterSelectGroup = selectGroup.filter((dt) => dt === competencyMapping[index]?.competency_category_group?.serial)
          if (filterSelectGroup.length > 0 && Util.formatData(competencyMapping[index]?.competency_category_group?.competencies, false) !== false && competencyMapping[index]?.competency_category_group?.competencies.length > 0) {
            newData = [...newData, ...competencyMapping[index]?.competency_category_group?.competencies]
          }
        }
      }
      setItem(newData)
      setMainItem(newData)
    } else {
      setItem(listCompetency)
      setMainItem(listCompetency)
    }
  }, [selectGroup]);

  let nextData = () => {
    let newData = []
    let data = olditemsCompetency
    let setdata = []

    if (select.length > 0) {
      for (let index = 0; index <= select.length - 1; index++) {
        let list = listCompetency.filter((rs) => rs?.serial === select[index])
        if (list.length > 0) {
          newData = [...newData, ...list]
        }
      }
      if (newData.length > 0) {
        for (let index = 0; index <= data.length - 1; index++) {
          data[index].competencies = []
        }
        newData.sort(function (b, a) {
          if (a.code > b.code) {
            return -1;
          }
          if (b.code > a.code) {
            return 1;
          }
          return 0;
        });
        for (let index = 0; index <= newData.length - 1; index++) {
          let indexofData = data.findIndex((rs) => rs?.serial === newData[index]?.competency_type?.serial)
          if (indexofData >= 0) {
            let odata = itemsCompetency[indexofData].competencies.filter((rs) => rs.serial === newData[index]?.serial)
            if (odata.length > 0) {
              data[indexofData].competencies = [...data[indexofData].competencies, ...odata]
            } else {
              data[indexofData].competencies = [...data[indexofData].competencies, newData[index]]
            }
          } else {
            let newGroup = newData[index]?.competency_type
            newGroup.competencies = []
            data.push(newGroup)
            data[data.length - 1].competencies = [newData[index]]
          }
        }

        for (let index = 0; index <= data.length - 1; index++) {
          if (data[index].competencies.length > 0) {
            setdata.push(data[index])
          }
        }
      }
    }
    next(setdata, select);
  }

  let checkExpandGroup = (data) => {
    let check = expandGroup.filter((rs) => rs === data)
    if (check.length > 0) {
      return true
    } else {
      return false
    }
  }

  let changeExpandGroup = (data) => {
    let check = expandGroup.filter((rs) => rs === data)
    if (check.length > 0) {
      let newData = expandGroup.filter((rs) => rs !== data)
      setExpandGroup(newData)
    } else {
      setExpandGroup([...expandGroup, data])
    }
  }

  let checkSelectGroup = (data) => {
    let check = selectGroup.filter((rs) => rs === data)
    if (check.length > 0) {
      return true
    } else {
      return false
    }
  }

  let changeSelectGroup = (data) => {
    let check = selectGroup.filter((rs) => rs === data)
    if (check.length > 0) {
      let newData = selectGroup.filter((rs) => rs !== data)
      setSelectGroup(newData)
    } else {
      setSelectGroup([...selectGroup, data])
    }
  }

  let checkIndeterminate = (serial, data) => {
    if (Util.formatData(data, false) !== false) {
      let is_check_true = 0
      let is_check_false = 0
      if (data.length > 0) {
        for (let index = 0; index <= data.length - 1; index++) {
          let filterData = selectGroup.filter((rs) => rs === data[index]?.serial)
          if (filterData.length === 0) {
            is_check_false++
          } else {
            is_check_true++
          }
        }
      } else {
        return false
      }
      if (is_check_true > 0 && is_check_false > 0) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  let checkSelectGroupAll = (serial, data) => {
    if (Util.formatData(data, false) !== false) {
      let is_check = true
      if (data.length > 0) {
        for (let index = 0; index <= data.length - 1; index++) {
          let filterData = selectGroup.filter((rs) => rs === data[index]?.serial)
          if (filterData.length === 0) {
            is_check = false
          }
        }
      } else {
        is_check = false
      }
      return is_check
    } else {
      let check = selectGroup.filter((rs) => rs === serial)
      if (check.length > 0) {
        return true
      } else {
        return false
      }
    }
  }

  let changeSelectGroupAll = (serial, data) => {
    if (Util.formatData(data, false) !== false) {
      let filterData = selectGroup
      let newData = []
      let checkAll = 0
      if (data.length > 0) {
        for (let index = 0; index <= data.length - 1; index++) {
          let setNew = filterData.filter((rs) => rs !== data[index]?.serial)
          if (setNew.length !== filterData.length) {
            checkAll++
          }

          filterData = setNew
          newData.push(data[index]?.serial)
        }
        if (checkAll === data.length) {
          setSelectGroup(filterData)
        } else {
          setSelectGroup([...filterData, ...newData])
        }
      }
    } else {
      let check = selectGroup.filter((rs) => rs === serial)
      if (check.length > 0) {
        let newData = selectGroup.filter((rs) => rs !== serial)
        setSelectGroup(newData)
      } else {
        setSelectGroup([...selectGroup, serial])
      }
    }
  }

  let checkExpand = (data) => {
    let check = expand.filter((rs) => rs === data)
    if (check.length > 0) {
      return true
    } else {
      return false
    }
  }

  let changeExpand = (data) => {
    let check = expand.filter((rs) => rs === data)
    if (check.length > 0) {
      let newData = expand.filter((rs) => rs !== data)
      setExpand(newData)
    } else {
      setExpand([...expand, data])
    }
  }

  let checkSelect = (data) => {
    let check = select.filter((rs) => rs === data)
    if (check.length > 0) {
      return true
    } else {
      return false
    }
  }

  let changeSelect = (data) => {
    let check = select.filter((rs) => rs === data)
    if (check.length > 0) {
      let newData = select.filter((rs) => rs !== data)
      setSelect(newData)
    } else {
      setSelect([...select, data])
    }
  }
  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => {return false}}
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" sx={{ pt: "21px", pb: "20px", px: "40px" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography fontSize={28} lineHeight="30.8px" fontWeight="600" color="#404349">{t('competencyMapping.addCompetency')}</Typography>
            <Box pr="45px" position="relative">
              <TextField
                id="input-with-icon-textfield"
                fullWidth
                placeholder={t('competencyMapping.searchCompetency')}
                size="small"
                sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" }, ".MuiOutlinedInput-root": { color: "#404349", } }}
                className="searchTextField-h40"
                value={search}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search style={{ color: "#C4C4C4" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
          <Divider sx={{ marginTop: "13px" }} />
        </DialogTitle>
        <DialogContent sx={{ px: "40px", py: 0 }}>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <Box sx={{ display: "flex", height: "calc(100vh - 285px)", width: "100%" }}>
              <Box sx={{ width: "300px", height: "100%", borderRight: "1px solid #DADADA" }} pr="40px">
                <Typography fontSize={14} lineHeight="24px" fontWeight="400" color="#AAAAAA">{t('evaluation.step')} 1</Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} pb="20px">
                  <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={24} lineHeight="24px" fontWeight="600" color="#404349">{t('competencyMapping.category')}</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={e => selectGroup.length > 0 ? setSelectGroup([]) : null}>
                    <CloseRed /><Typography fontSize={14} lineHeight="20.93px" fontWeight="400" color="#CC6058" pl="5px" >{t('competencyMapping.deselectAll')}</Typography>
                  </Box>
                </Box>
                <Box sx={{ height: "calc(100% - 68px)", overflowY: "auto" }}>
                  {competencyMapping.length > 0 ?
                    competencyMapping.map((rs, id) => (
                      <Box sx={{ borderBottom: "1px solid #CED4DA" }} pr="5px" pt={id === 0 ? "" : "24px"} pb="24px">
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ display: "flex", alignItems: "center", width: "calc(100% - 20px)" }} pr="10px">
                            <Checkbox color="primary"
                              checked={checkSelectGroupAll(rs?.competency_category_group?.serial, rs?.competency_category_subgroup)}
                              indeterminate={checkIndeterminate(rs?.competency_category_group?.serial, rs?.competency_category_subgroup)}
                              onClick={e => changeSelectGroupAll(rs?.competency_category_group?.serial, rs?.competency_category_subgroup)}
                              sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" }, mr: "11px" }} />
                            <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={18} lineHeight="18px" fontWeight="500" color="#404349">{rs?.competency_category_group?.name}</Typography>
                          </Box>
                          {Util.formatData(rs?.competency_category_subgroup, false) !== false ?
                            checkExpandGroup(rs?.competency_category_group?.serial) ?
                              <ExpandDownAddCompetency style={{ cursor: "pointer" }} onClick={e => changeExpandGroup(rs?.competency_category_group?.serial)} />
                              :
                              <ExpandRightAddCompetency style={{ cursor: "pointer" }} onClick={e => changeExpandGroup(rs?.competency_category_group?.serial)} />
                            :
                            null
                          }
                        </Box>
                        {Util.formatData(rs?.competency_category_subgroup, false) !== false ? (
                          <Collapse in={checkExpandGroup(rs?.competency_category_group?.serial)}>
                            <Box pl="34.7px" pt="18px">
                              {rs?.competency_category_subgroup.map((dt, row) => (
                                <Box sx={{ display: "flex", alignItems: "center", width: "100%" }} mt="7.5px" mb={row === rs?.competency_category_subgroup.length - 1 ? "" : "7.5px"}>
                                  <Checkbox color="primary"
                                    checked={checkSelectGroup(dt?.serial)}
                                    onClick={e => changeSelectGroup(dt?.serial)}
                                    sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" }, mr: "11px" }} />
                                  <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={16} lineHeight="18px" fontWeight="400" color="#404349">{dt?.name}</Typography>
                                </Box>
                              ))}
                            </Box>
                          </Collapse>)
                          :
                          null
                        }
                      </Box>
                    ))
                    : null
                  }
                </Box>
              </Box>
              <Box sx={{ width: "calc(100% - 300px)", height: "100%" }} pl="40px">
                <Box sx={{ display: "flex", justifyContent: "space-between" }} pb="20px">
                  <Box>
                    <Typography fontSize={14} lineHeight="24px" fontWeight="400" color="#AAAAAA">{t('evaluation.step')} 2</Typography>
                    <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={24} lineHeight="24px" fontWeight="600" color="#404349" pb="7px">{t('competencyMapping.competencyItem')}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", }}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} mb="7px" onClick={e => select.length > 0 ? setSelect([]) : null}>
                        <CloseRed /><Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={14} lineHeight="20.93px" fontWeight="400" color="#CC6058" pl="5px" >{t('competencyMapping.deselectAll')}</Typography>
                      </Box>
                      <Box sx={{ display: "flex", height: "37px", alignItems: "center", background: "rgba(93, 161, 150, 0.1)", borderRadius: "5px" }} p="5px 10px" ml="20px">
                        <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={18} lineHeight="26.91px" fontWeight="400" color="#5DA196" >{t('competencyMapping.selectedCompetency')}:</Typography>
                        <Typography fontSize={18} lineHeight="26.91px" fontWeight="400" color="#5DA196" pl="10px">{select?.length}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ height: "calc(100% - 75px)", overflowY: "auto" }}>
                  {item.length > 0 ?
                    item.map((rs, id) => (
                      <Box pt={id === 0 ? "" : "20px"}>
                        <Box >
                          <Box sx={{ display: "flex", alignItems: "center" }} pr="5px">
                            <Box sx={{ display: "flex", alignItems: "center", width: "calc(100% - 20px)" }} pr="20px">
                              <Checkbox color="primary" checked={checkSelect(rs?.serial)} onClick={e => changeSelect(rs?.serial)} sx={{ p: 0, ".MuiSvgIcon-root": { width: "26.7px", height: "26.7px" }, mr: "30px" }} />
                              <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} fontSize={20} lineHeight="22px" fontWeight="600" color="#404349">{rs?.name}</Typography>
                            </Box>
                            {
                              checkExpand(rs?.serial) ?
                                <ExpandDownAddCompetency style={{ cursor: "pointer" }} onClick={e => changeExpand(rs?.serial)} />
                                :
                                <ExpandRightAddCompetency style={{ cursor: "pointer" }} onClick={e => changeExpand(rs?.serial)} />
                            }
                          </Box>
                          {/* 14.91 + 32.13 + 20.72 +32.24 */}
                          <Box pl="56.7px"  >
                            <Box sx={{ display: "flex", alignItems: "center", }} pt="20px">
                              <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "14.91%" }} pr="10px" fontSize={16} lineHeight="17.6px" fontWeight="400" color="#404349">{rs?.code}</Typography>
                              <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "30.13%" }} pr="10px" fontSize={16} lineHeight="17.6px" fontWeight="600" color="#404349">
                                {t('label.titleForm.type')}: <span style={{ fontWeight: "400" }}>{rs?.competency_type?.name}</span>
                              </Typography>
                              <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "22.72%" }} pr="10px" fontSize={16} lineHeight="17.6px" fontWeight="600" color="#404349">
                                {t('competencyMapping.group')}: <span style={{ fontWeight: "400" }}>{rs?.category_group?.name}</span>
                              </Typography>
                              <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "32.24%" }} pr="10px" fontSize={16} lineHeight="17.6px" fontWeight="600" color="#404349">
                                {t('admin.inputForm.subGroup')}: <span style={{ fontWeight: "400" }}>{rs?.category_subgroup?.name}</span>
                              </Typography>
                            </Box>
                            <Collapse in={checkExpand(rs?.serial)}>
                              {Util.formatData(rs?.description, false) !== false ?
                                <Box pt="20px">
                                  <Typography pr="10px" fontSize={16} lineHeight="24px" fontWeight="400" color="#404349">{rs?.description}</Typography>
                                </Box>
                                :
                                null
                              }
                              {rs?.have_proficiency === false && Util.formatData(rs?.competency_behavioral, false) !== false && rs?.competency_behavioral.length > 0 ? (
                                <Box sx={{ display: "flex", }} pt={Util.formatData(rs?.competency_behavioral, false) !== false ? "10px" : "20px"}>
                                  <Box sx={{ width: "130px" }}>
                                    <Typography fontSize={16} lineHeight="17.6px" fontWeight="600" color="#404349">{t('competency.behaviors')}</Typography>
                                  </Box>
                                  <Box sx={{ width: "calc(100% - 130px)", ".MuiTypography-root": { "&:before": { content: '""', width: "5px", height: "5px", background: "#000000", borderRadius: "50%", marginBottom: "4px", marginRight: "10px", marginLeft: "10px", display: "inline-block", } } }}>
                                    {rs?.competency_behavioral.map((rs) => (
                                      <Typography fontSize={16} lineHeight="24px" fontWeight="400" color="#404349" >{rs?.name}</Typography>
                                    ))}
                                  </Box>
                                </Box>
                              )
                                :
                                null
                              }
                            </Collapse>
                            <Divider sx={{ mt: "20px" }} />
                          </Box>
                        </Box>
                      </Box>
                    ))
                    :
                    <Box sx={{ height: "calc(100% - 60px)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }}>
                      <img src={emty} alt="emtyData" style={{ height: "81px" }}></img>
                      <Typography fontSize={16} lineHeight="23.92px" fontWeight="400" color="#A0A0A0">{t('competencyMapping.pleaseSelect')}</Typography>
                    </Box>
                  }
                </Box>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: "40px 40px 27px" }}>
          <Button onClick={handleConfirm} size="medium" variant="outlined" sx={{ width: '150px', marginRight: "10px" }} color="black">
            <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">{t('competencyMapping.cancel')}</Typography>
          </Button>
          <Button size="medium" variant="contained" sx={{ width: '150px' }} onClick={nextData}>
            <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">{t('competencyMapping.next')}</Typography>
          </Button>
        </DialogActions>
      </Dialog >
      <ConfirmDialog
        warning={true}
        open={isConfirmOpen}
        doConfirm={handleConfirmDeleteList}
        setValue={handleConfirm}
        title={t('label.confirmationOfDiscard')}
        text={t('label.youSureDiscardChange')}
      />
    </React.Fragment >
  );
};
export default SimpleDialog;
